module.exports = __webpack_public_path__ + "static/WEDDING E&M-162-783e52b8bc6b5a5b82e0332ed0ee9797.jpg";